import Product from "@/Controller/Product";
window.app = new Product;